import { store } from '@tubo/society-base'

export default store
